import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app";
// import * as Sentry from "@sentry/react";

// Sentry.init({
//   dsn: "https://8cab85f6af0108611ffbfd6b2cc1c47e@sentry.wb.ru//425",
// });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
